.searchRow {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-x-small);
}

.separator {
    border-left: 1px solid var(--exo-color-border-secondary);
    height: var(--exo-spacing-medium);
}

.trailingActions {
    margin-left: auto;
}

.wrapper {
    overflow: auto;
}

.table {
    width: 100%;
    border-collapse: collapse;
    font-size: var(--exo-font-size-small);
}

.tableHead th {
    padding: var(--exo-spacing-standard);
    text-align: left;
    font-size: var(--exo-font-size-small);
    font-weight: var(--exo-font-weight-semi-bold);
    color: var(--exo-color-font);
    border-bottom: 1px solid var(--exo-palette-gray-80);
    white-space: nowrap;
    user-select: none;
}

.row:nth-child(even) {
    background-color: var(--exo-color-background-secondary);
}

.row td {
    padding: var(--exo-spacing-standard);
    vertical-align: middle;
}

.pagination {
    display: flex; /* ignores padding without this */
    padding: var(--exo-spacing-standard);
}
